<template>
  <svg
    fill="currentColor"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M128,28A100,100,0,1,0,228,128,100.1127,100.1127,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.10478,92.10478,0,0,1,128,220Zm23.10254-100.18262L112.001,171.99414H152a4,4,0,0,1,0,8H104.2207c-.07324.00391-.14746.00586-.22168.00586a4.00182,4.00182,0,0,1-3.13281-6.48828l43.77246-58.40918A20.00419,20.00419,0,1,0,109.56934,96.2168a3.99976,3.99976,0,0,1-7.36719-3.11719,28.004,28.004,0,1,1,49.01367,26.55859C151.17969,119.71191,151.1416,119.76563,151.10254,119.81738Z" />
  </svg>
</template>
